import { useAuth, overrideConfig } from '@/api/billing-primary'

const service = {
    fetchSummary ({ projectIdx, month }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.post('/v1/context', { target: 'Summary', params: { projectIdx, month } })
    },
    fetchSummaryDetail ({ projectIdx, month, productCode, region, date }, serviceIdx) {
        const { auth } = useAuth({ ...overrideConfig, serviceIdx })
        return auth.axiosIns.post('/v1/context', { target: 'SummaryDetail', params: { projectIdx, month, productCode, region, date } })
    }
}

export const {
    fetchSummary,
    fetchSummaryDetail
} = service

export default service
